import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const HelpIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "HelpIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M12 22C6.48584 22 2 17.5142 2 12C2 6.48584 6.48584 2 12 2C17.5142 2 22 6.48584 22 12C22 17.5142 17.5142 22 12 22ZM12 3C7.0376 3 3 7.0376 3 12C3 16.9624 7.0376 21 12 21C16.9624 21 21 16.9624 21 12C21 7.0376 16.9624 3 12 3Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12 14.9097C11.7236 14.9097 11.5 14.686 11.5 14.4097V12.3442C11.5 12.0679 11.7236 11.8442 12 11.8442C13.1191 11.8442 14.0298 10.9336 14.0298 9.81445C14.0298 8.6953 13.1192 7.78466 12 7.78466C10.8808 7.78466 9.97021 8.6953 9.97021 9.81445C9.97021 10.0908 9.74658 10.3145 9.47021 10.3145C9.19384 10.3145 8.97021 10.0908 8.97021 9.81445C8.97021 8.14404 10.3296 6.78466 12 6.78466C13.6704 6.78466 15.0298 8.14404 15.0298 9.81445C15.0298 11.3149 13.9336 12.564 12.5 12.8032V14.4097C12.5 14.686 12.2764 14.9097 12 14.9097Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12 17.2847C11.7236 17.2847 11.5 17.061 11.5 16.7847V16.6812C11.5 16.4048 11.7236 16.1812 12 16.1812C12.2764 16.1812 12.5 16.4048 12.5 16.6812V16.7847C12.5 17.061 12.2764 17.2847 12 17.2847Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default HelpIcon;
